import Image from 'next/future/image';
import { DeviceImageProps } from './types';
import shieldIcon from '@/public/icons/buyback/sell-device/shield.svg';

const DeviceImage = ({ imageUrl }: DeviceImageProps) => (
  <div className="hidden h-[75px] w-[75px] sm:block">
    <div className="relative h-full w-full">
      <Image
        src={imageUrl}
        height={300}
        width={300}
        alt="Product"
        className="h-full w-full object-contain mix-blend-multiply"
      />
      <div className="absolute -top-4 -right-3 h-12 w-12">
        <Image
          src={shieldIcon}
          height={50}
          width={50}
          alt="ReebeloCare"
          className="h-full w-full object-cover"
        />
      </div>
    </div>
  </div>
);

export default DeviceImage;
